<div class="tfa-modal">

  <!-- Badge -->
  <div class="tfa-modal__badge">
    <svg class="tfa-modal__shield"
         fill="none"
         viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L3 6v6c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V6L12 2z"
            fill="currentColor"
            opacity=".15"></path>
      <path d="M12 2L3 6v6c0 5.25 3.75 10.15 9 11.35C17.25 22.15 21 17.25 21 12V6L12 2z"
            stroke="currentColor"
            stroke-linejoin="round"
            stroke-width="1.5"></path>
      <path d="M9 12l2 2 4-4"
            stroke="white"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.8"></path>
    </svg>
  </div>

  <!-- Header -->
  <h2 class="tfa-modal__title">
    Verify your identity
  </h2>
  <p class="tfa-modal__subtitle">
    Enter the 6-digit code sent to your
    <strong>
      {{data.method === 'sms' ? 'phone' : 'email'}}
    </strong>
    .
  </p>

  <!-- Code input -->
  <div class="tfa-modal__input-wrap">
    <input #codeInput

           class="tfa-modal__code-input"
           autocomplete="one-time-code"
           maxlength="6"
           placeholder="— — — — — —"
           type="text"
           inputmode="numeric"

           [(ngModel)]="code"
           (keyup.enter)="validateCode()">
    <div class="tfa-modal__input-bar"
         [class.tfa-modal__input-bar--filled]="code.length === 6"></div>
  </div>

  <!-- Error -->
  <p *ngIf="error"
     class="tfa-modal__error">
    <svg height="14"
         width="14"
         fill="currentColor"
         viewBox="0 0 20 20">
      <path clip-rule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            fill-rule="evenodd"></path>
    </svg>
    {{ error }}
  </p>

  <!-- Actions -->
  <div class="tfa-modal__actions">
    <button class="tfa-modal__btn tfa-modal__btn--verify"
            [class.tfa-modal__btn--loading]="verifying"
            [disabled]="code.length < 6 || verifying"
            (click)="validateCode()">
      <span *ngIf="!verifying">
        Verify
      </span>
      <span *ngIf="verifying"
            class="tfa-modal__spinner"></span>
    </button>
  </div>

  <!-- Footer -->
  <div class="tfa-modal__footer">
    <button class="tfa-modal__link"
            [disabled]="counter > 0"
            (click)="handleResend()">
      {{ counter > 0 ? 'Resend in ' + counter + 's' : 'Send a new code' }}
    </button>
    <button class="tfa-modal__link tfa-modal__link--cancel"
            (click)="handleCancel()">
      Sign out
    </button>
  </div>

</div>
